import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dataUtils from "../../../../../../common/utils/dataUtils";

type Props = {
  onActionEditar: (Id: number | null, openState: boolean, openAnalise: boolean) => void,
  onActionDeletar: (Id: number | null, openState: boolean) => void,
};

export const GenerateInformacoesColumns = ({
  onActionEditar,
  onActionDeletar,
}: Props): GridColDef[] => {

  return [
    {
      field: "NomeFuncionario",
      filterable: false,
      headerName: "Nome Funcionario",
      flex: 1,
      minWidth: 300,
      sortable: false,
      renderCell: (params) => {
        return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "Data",
      filterable: false,
      headerName: "Data",
      flex: 1,
      maxWidth: 100,
      sortable: false,
      renderCell: (params) => {
            return (<div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
              {dataUtils.dataFormatada(params.value ? params.value : null)}
            </div>);
          },
    },
    {
      field: "DescInformacoes",
      filterable: false,
      headerName: "Informações",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: 'IdContratoInformacoes',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      minWidth: 100,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEditar(params.value, true, false)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onActionDeletar(params.value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}